export default "__VITE_ASSET__8d30dd2d__"